import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const META_DESCRIPTIONS: Record<string, string> = {
  '/': 'Simsola AI is an AI-powered training platform helping leaders build collaboration, influence, and decision-making skills through immersive scenarios.',
  '/about-us': 'Learn about Simsola AI, our mission, and how we are transforming leadership training through immersive AI-powered experiences.',
  '/assessment-service': 'Run consistent, API-first candidate assessments with Simsola. Start a free trial on the Base plan or contact Sales for Enterprise.',
  '/assessment-service/candidates': 'Upload a real interview and get a private, skill-by-skill report with quotes from your own answers and what to sharpen before your next round.',
  '/book-a-demo': 'Book a personalized demo of Simsola AI and explore how immersive AI training can elevate leadership and team performance.',
  '/contact-us': 'Contact the Simsola AI team to learn more about our AI training platform, partnerships, and enterprise solutions.',
  '/news/tmn-choice-awards-2026': 'Training Magazine Network members voted Simsola a winner in the Immersive & Spatial Learning Technologies category of the 2026 Training Magazine Network Choice Awards.',
  '/privacy-policy': 'Read Simsola AI’s privacy policy to understand how we collect, use, and protect your personal information.',
  '/product': 'Explore Simsola AI’s product features designed to deliver immersive, AI-driven leadership training experiences.',
  '/product/6d-assessment': 'Evaluate leadership across Influence, Curiosity, Courage, Humility, Empathy, and Collaboration with Simsola’s 6D Assessment.',
  '/resource-download': 'Download Simsola AI’s free whitepaper on Leadership Development in the AI Era.',
  '/resources': 'Access Simsola AI resources including blogs, guides, workshops, and events focused on leadership and AI training.',
  '/results': 'Discover the measurable results and impact organizations achieve using Simsola AI’s leadership training platform.',
  '/terms-of-use': 'Review Simsola AI’s terms of use outlining platform access, responsibilities, and acceptable usage.',
  '/trust-center': 'Learn how Simsola AI ensures security, privacy, and compliance across its AI training platform.',
  '/vision': 'Explore Simsola AI’s vision for the future of AI-powered leadership training and immersive learning.'
};

export const SeoMetaDescription = () => {
  const location = useLocation();
  const description = META_DESCRIPTIONS[location.pathname];

  if (!description) return null;

  return (
    <Helmet>
      <meta name="description" content={description} />
    </Helmet>
  );
};
